
import * as Icons from "lucide-react";
import { Service } from "@/types/marketplace";

interface IconRendererProps {
  iconName: Service["iconName"];
  className?: string;
}

export const IconRenderer = ({ iconName, className = "" }: IconRendererProps) => {
  const IconComponent = Icons[iconName] as unknown as React.ComponentType<{ className?: string }>;
  return <IconComponent className={`text-sky-500 ${className}`} />;
};
